export enum FieldOrientationEnum {
    vertical = 'vertical',
    horizontal = 'horizontal'
}

export enum LabelPositionEnum {
    before = 'before',
    after = 'after'
}
